import { render, staticRenderFns } from "./postComponent.vue?vue&type=template&id=cfc9159a"
import script from "./postComponent.vue?vue&type=script&lang=js"
export * from "./postComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiIconsTag: require('/home/node/app/components/ui/icons/tag.vue').default,UiIconsArrow: require('/home/node/app/components/ui/icons/arrow.vue').default,UiSecondaryButton: require('/home/node/app/components/ui/secondaryButton.vue').default})
